import {
  // commandCenterIcon,
  // marketingCenterIcon,
  // reportingCenterIcon,
  // workforceCenterIcon,
  commandCenterIconV1,
  workforceCenterIconv1,
  marketingCenterIconv1,
  thryvGrowthPlatformIcon,
  businessCenterIconv1,
  reportingCenterIconv1,
  enhancedAccessibilityIcon,
  signaturesIcon,
  thryvLeadsIcon,
  // businessCenterIcon,
  seoIcon,
  hipaaIcon,
  websiteBuilderIcon,
  cloverAppIcon,
  constantContactIcon,
  copperAppIcon,
  xeroAppIcon,
  googleSheetAppIcon,
  hubspotAppIcon,
  insightlyAppIcon,
  instagramAppIcon,
  jotFormIcon,
  mailchimpIcon,
  myobAppIcon,
  quickbooksAppIcon,
  quickbooksDesktopIcon,
  ringCentralIcon,
  shopifyAppIcon,
  smartDataImporterIcon,
  twillioAppIcon,
  webchatAppIcon,
  facebookMessengerIconApp,
  typeFormIcon,
  restrictedAccessIcon,
  gmailLogo,
  googleLogo,
  marketplaceIcon,
  logoBuilderIcon,
  customVideoShootIcon,
  listingsAppIcon,
  growthPackageIcon,
  seoKeywordsIcon,
  seoPowerboostIcon,
  socialAdsIcon,
  supportCenter,
  ThryvSocialPostsIcon,
  keapMaxIcon,
  thryvPayIconv1,
  zapierPromotionIcon,
  reverseOrangePlusIcon,
  reverseGreenPlusIcon,
  supportV2Icon,
  connectIcon,
  textingIcon,
  phoneMessageIcon,
  profileIcon,
  manageContactsIcon,
  oneHourIcon,
  worldIcon,
  uploadDocumentIcon,
  complianceIcon,
  diyWebsiteIcon,
  videoSupportIcon,
  digitalThryvToolsIcon,
  messagingv2Icon,
  keapQuickLaunchIcon,
  listingRefreshIcon,
  strategicContentCreationIcon,
  adsBoostIcon,
  brandBoostIcon,
  socialBoostIcon,
  searchBoostIcon,
} from '../assets'
const PLANS_ICONS = [
  {
    name: 'my account',
    icon: commandCenterIconV1,
  },
  {
    name: 'business center',
    icon: businessCenterIconv1,
  },
  {
    name: 'marketing center',
    icon: marketingCenterIconv1,
  },
  {
    name: 'reporting center',
    icon: reportingCenterIconv1,
  },
  {
    name: 'workforce center',
    icon: workforceCenterIconv1,
  },
  {
    name: 'enhanced accessibility',
    icon: enhancedAccessibilityIcon,
  },
  {
    name: 'signatures',
    icon: signaturesIcon,
  },
  {
    name: 'leads',
    icon: thryvLeadsIcon,
  },
  {
    name: 'thryv leads',
    icon: thryvLeadsIcon,
  },
  {
    name: 'seo',
    icon: seoIcon,
  },
  {
    name: 'hipaa',
    icon: hipaaIcon,
  },
  {
    name: 'website',
    icon: websiteBuilderIcon,
  },
  {
    name: 'clover',
    icon: cloverAppIcon,
  },
  {
    name: 'constant contact',
    icon: constantContactIcon,
  },
  {
    name: 'copper',
    icon: copperAppIcon,
  },
  {
    name: 'xero app',
    icon: xeroAppIcon,
  },
  {
    name: 'google sheets',
    icon: googleSheetAppIcon,
  },
  {
    name: 'hubspot',
    icon: hubspotAppIcon,
  },
  {
    name: 'insightly',
    icon: insightlyAppIcon,
  },
  {
    name: 'instagram messenger',
    icon: instagramAppIcon,
  },
  {
    name: 'jotform',
    icon: jotFormIcon,
  },
  {
    name: 'mailchimp',
    icon: mailchimpIcon,
  },
  {
    name: 'myob',
    icon: myobAppIcon,
  },
  {
    name: 'quickbooks app',
    icon: quickbooksAppIcon,
  },
  {
    name: 'quickbooks desktop',
    icon: quickbooksDesktopIcon,
  },
  {
    name: 'ringcentral',
    icon: ringCentralIcon,
  },
  {
    name: 'shopify',
    icon: shopifyAppIcon,
  },
  {
    name: 'app-smartdataimporter',
    icon: smartDataImporterIcon,
  },
  {
    name: 'twilio app',
    icon: twillioAppIcon,
  },
  {
    name: 'web chat app',
    icon: webchatAppIcon,
  },
  {
    name: 'facebook business messenger app',
    icon: facebookMessengerIconApp,
  },
  {
    name: 'typeform app',
    icon: typeFormIcon,
  },
  {
    name: 'growth package',
    icon: growthPackageIcon,
  },
  {
    name: 'starter growth package',
    icon: growthPackageIcon,
  },
  {
    name: 'expanded growth package',
    icon: growthPackageIcon,
  },
  {
    name: 'restricted access',
    icon: restrictedAccessIcon,
  },
  {
    name: 'gmail',
    icon: gmailLogo,
  },
  {
    name: 'google business profile',
    icon: googleLogo,
  },
  {
    name: 'thryv add-ons',
    icon: reverseOrangePlusIcon,
  },
  {
    name: 'thryv marketplace',
    icon: marketplaceIcon,
  },
  {
    name: 'logo',
    icon: logoBuilderIcon,
  },
  {
    name: 'custom video',
    icon: customVideoShootIcon,
  },
  {
    name: 'listings management',
    icon: listingsAppIcon,
  },
  {
    name: 'seo keywords',
    icon: seoKeywordsIcon,
  },
  {
    name: 'seo powerboost',
    icon: seoPowerboostIcon,
  },
  {
    name: 'social ads',
    icon: socialAdsIcon,
  },
  {
    name: 'thryv social posts',
    icon: ThryvSocialPostsIcon,
  },
  {
    name: 'thryv 24x7 support and service fee',
    icon: supportCenter,
  },
  {
    name: 'keap add-ons',
    icon: reverseGreenPlusIcon,
  },
  {
    name: 'thryv pay',
    icon: thryvPayIconv1,
  },
  {
    name: 'thryvpay',
    icon: thryvPayIconv1,
  },
  {
    name: 'zapier',
    icon: zapierPromotionIcon,
  },
  {
    name: 'keap max',
    icon: keapMaxIcon,
  },

  {
    name: 'hvac',
    icon: keapMaxIcon,
  },
  {
    name: 'roofing',
    icon: keapMaxIcon,
  },
  {
    name: 'electrical',
    icon: keapMaxIcon,
  },
  {
    name: 'plumbing',
    icon: keapMaxIcon,
  },
  {
    name: 'included text & voice',
    icon: keapMaxIcon,
  },
  {
    name: 'included user',
    icon: keapMaxIcon,
  },
  {
    name: 'included contacts',
    icon: keapMaxIcon,
  },
  {
    name: 'keapcertification',
    icon: keapMaxIcon,
  },
  {
    name: 'kcp certification',
    icon: keapMaxIcon,
  },
  {
    name: 'coach builder',
    icon: keapMaxIcon,
  },
  {
    name: 'silver service package',
    icon: supportV2Icon,
  },
  {
    name: 'platinum standard service package',
    icon: supportV2Icon,
  },
  {
    name: 'platinum premium service package',
    icon: supportV2Icon,
  },
  {
    name: 'platinum plus service package',
    icon: supportV2Icon,
  },
  {
    name: 'limited e-commerce crm import',
    icon: connectIcon,
  },
  {
    name: 'keap text & voice',
    icon: textingIcon,
  },
  {
    name: 'keap gmail standard',
    icon: keapMaxIcon,
  },
  {
    name: 'keap business line',
    icon: phoneMessageIcon,
  },
  {
    name: 'additional users',
    icon: profileIcon,
  },
  {
    name: 'additional contacts',
    icon: manageContactsIcon,
  },
  {
    name: 'additional graphly contacts',
    icon: keapMaxIcon,
  },
  {
    name: 'plusthis premium',
    icon: keapMaxIcon,
  },
  {
    name: 'hourly data service',
    icon: oneHourIcon,
  },
  {
    name: 'gold service package',
    icon: supportV2Icon,
  },
  {
    name: 'e-commerce data transfer',
    icon: connectIcon,
  },
  {
    name: 'e-commerce data import',
    icon: connectIcon,
  },
  {
    name: 'dedicated ip',
    icon: worldIcon,
  },
  {
    name: 'data restore',
    icon: uploadDocumentIcon,
  },
  {
    name: 'custom done for you',
    icon: complianceIcon,
  },
  {
    name: 'credit card import',
    icon: connectIcon,
  },
  {
    name: 'convrrt',
    icon: diyWebsiteIcon,
  },
  {
    name: 'basic crm data import',
    icon: connectIcon,
  },
  {
    name: 'ask the expert',
    icon: videoSupportIcon,
  },
  {
    name: 'api calls - 500k/month',
    icon: digitalThryvToolsIcon,
  },
  {
    name: 'advanced data transfer',
    icon: connectIcon,
  },
  {
    name: 'advanced crm data import',
    icon: connectIcon,
  },
  {
    name: '500 additional message bundle',
    icon: messagingv2Icon,
  },
  {
    name: 'quick launch',
    icon: keapQuickLaunchIcon,
  },
  {
    name: 'thryv growth platform',
    icon: thryvGrowthPlatformIcon,
  },
  {
    name: 'signature plus',
    icon: thryvGrowthPlatformIcon,
  },
  {
    name: 'starter (monthly)',
    icon: thryvGrowthPlatformIcon,
  },
  {
    name: 'signature (monthly)',
    icon: thryvGrowthPlatformIcon,
  },
  {
    name: 'premier (monthly)',
    icon: thryvGrowthPlatformIcon,
  },
  {
    name: 'starter (annual)',
    icon: thryvGrowthPlatformIcon,
  },
  {
    name: 'signature (annual)',
    icon: thryvGrowthPlatformIcon,
  },
  {
    name: 'premier (annual)',
    icon: thryvGrowthPlatformIcon,
  },
  {
    name: 'listing refresh',
    icon: listingRefreshIcon,
  },
  {
    name: 'strategic content creation',
    icon: strategicContentCreationIcon,
  },
  {
    name: 'kcc certification',
    icon: keapMaxIcon,
  },
  {
    name: 'keap',
    icon: keapMaxIcon,
  },
  {
    name: 'ads boost',
    icon: adsBoostIcon,
  },
  {
    name: 'brand boost',
    icon: brandBoostIcon,
  },
  {
    name: 'social boost',
    icon: socialBoostIcon,
  },
  {
    name: 'search boost',
    icon: searchBoostIcon,
  },
]
const fetchPlanIcon = planName => {
  let imageDetails = PLANS_ICONS.find(item => {
    return planName?.toLowerCase().includes(item.name)
  })
  return imageDetails
}

export {fetchPlanIcon}
